import styled from 'styled-components';
import { breakpoints } from 'stylesheet';

export const Styles = {
  Mobile: styled.div`
    @media (min-width: ${breakpoints.small}) {
      display: none;
    }
  `,
  Desktop: styled.div`
    @media (max-width: ${breakpoints.small}) {
      display: none;
    }
  `,
};
